import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ExpandableText from './ExpandableText'
import { AnswerLabel, ChosenOption, OpenDetailButton, useAnswerLabel } from './ArchiveBodies'

// Questions previewed on the card; the full set opens in the results modal.
const PREVIEW_COUNT = 2

const hasAnswer = (answer) => (Array.isArray(answer) ? answer.some((a) => `${a}`.trim()) : answer !== undefined && answer !== null && `${answer}`.trim() !== '')

const answerText = (answer) => (Array.isArray(answer) ? answer.filter((a) => `${a}`.trim()).join(', ') : `${answer}`)

function SurveyAnswer({ question }) {
    const { t } = useTranslation()
    if (!hasAnswer(question.answer)) return <p className="archive-muted">{t('archiveNotAnswered')}</p>

    if (question.type === 'openAnswer') {
        return <ExpandableText text={answerText(question.answer)} lines={3} className="archive-quote-text archive-quote-text--inline" />
    }
    // options / yesNo (and anything newer) are a single chosen value, shown as the selected option.
    return (
        <ul className="archive-options archive-survey-choice">
            <ChosenOption>{answerText(question.answer)}</ChosenOption>
        </ul>
    )
}

export default function SurveyBody({ content, response, onOpen }) {
    const { t } = useTranslation()
    const answerLabel = useAnswerLabel()

    const questions = useMemo(() => (response.sections || []).flatMap((section) => (section?.questions || []).filter(Boolean)), [response.sections])
    const answered = questions.filter((question) => hasAnswer(question.answer)).length
    const preview = questions.slice(0, PREVIEW_COUNT)

    return (
        <>
            {!!content?.title && <h3 className="archive-title">{content.title}</h3>}
            {questions.length > 0 && (
                <div className="archive-progress">
                    <span className="archive-progress-track">
                        <span className="archive-progress-fill" style={{ transform: `scaleX(${answered / questions.length})` }} />
                    </span>
                    <span className="archive-progress-text">{t('archiveSurveyProgress', { answered, total: questions.length })}</span>
                </div>
            )}
            {preview.length > 0 && <AnswerLabel>{answerLabel(2)}</AnswerLabel>}
            <ol className="archive-survey-list">
                {preview.map((question, index) => (
                    <li key={index} className="archive-survey-item">
                        <p className="archive-survey-question">
                            <span className="archive-survey-number">{index + 1}</span>
                            {question.title}
                        </p>
                        <SurveyAnswer question={question} />
                    </li>
                ))}
            </ol>
            <OpenDetailButton onClick={onOpen}>{t('archiveViewSurvey', { count: questions.length })}</OpenDetailButton>
        </>
    )
}
